import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BackendServiceResponse} from '../../model/backend-service-response';
import {environment} from '../../environments/environment';
import {Report} from '../../model/report';
import {MasbitHttpService} from '../../common/http/masbit-http.service';

@Injectable()
export class UserSavedReportsService {

  private static readonly REPORT_LIST_REMOVE_FROM_SAVED_SERVICE_URL = environment.apiUrl.concat(environment.reportRemoveFromFavourites);
  private static readonly REPORT_GET_SAVED_BY_USER_SERVICE_URL = environment.apiUrl.concat(environment.reportGetFavourites);
  private static readonly REPORT_GET_SAVED_BY_USER_SERVICE_COUNT_URL = environment.apiUrl.concat(environment.reportGetFavouritesCount);

  constructor(private httpClient : MasbitHttpService) { }

  public removeReportsFromSaved(userId : number, reportIds : Array<number>) : Observable<BackendServiceResponse<number, string>> {
    return this.httpClient.post<BackendServiceResponse<number, string>>(UserSavedReportsService.REPORT_LIST_REMOVE_FROM_SAVED_SERVICE_URL, {userId : userId, reportId : reportIds});
  }

  public getReports(filterParams : any) : Observable<BackendServiceResponse<number, Array<Report>>> {
    return this.httpClient.post<BackendServiceResponse<number, Array<Report>>>(UserSavedReportsService.REPORT_GET_SAVED_BY_USER_SERVICE_URL, filterParams);
  }

  public getReportsCount(filterParams : any) : Observable<BackendServiceResponse<number, number>> {
    return this.httpClient.post<BackendServiceResponse<number, number>>(UserSavedReportsService.REPORT_GET_SAVED_BY_USER_SERVICE_COUNT_URL, filterParams);
  }
}
